import { render, staticRenderFns } from "./SDAProductItem.vue?vue&type=template&id=d66c032c&scoped=true"
import script from "./SDAProductItem.vue?vue&type=script&lang=js"
export * from "./SDAProductItem.vue?vue&type=script&lang=js"
import style0 from "./SDAProductItem.vue?vue&type=style&index=0&id=d66c032c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66c032c",
  null
  
)

export default component.exports